<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<div class="container">
				<div class="row mb-3">
					<div class="col ">
						<div class="d-flex">
							<h3 class="mt-4">{{ title }}</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="container mb-3">
				<div class="row">
					<div class="col-12 col-sm-6 col-md-4 col-lg-3 " v-for="item in list" :key="item.id">
						<div>
							<EventItem :event="item" />
						</div>
					</div>
				</div>
				<div class="row" v-if="!loading && list.length == 0">
					<div class="col-12 text-center ">
						<h6 class="my-5 py-5 ">
							No hemos encontrado eventos que coincidan con tu búsqueda
						</h6>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import EventItem from "@/views/events/EventItem"

export default {
	name: "EventList",
	components: {
		Layout,
		EventItem
	},
	data() {
		return {
			loading: false,
			title: "Eventos populares",
			list: []
		}
	},

	async beforeMount() {
		this.filters = this.getValidUrlParams()

		if (this.filters.s) this.title = "Resultados de la búsqueda"
		if (this.$route.params.category) this.title = "Eventos en " + this.$route.params.category

		await this.load()
	},

	methods: {
		load() {
			console.log(this.filters)
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String, $category: String) {
							events(take: $take, skip: $skip, search: $search, category: $category) {
								data {
									id
									code
									name
									startAt
									endAt
									description
									image {
										id
										type
										filename
										url
										urlThumb
									}
									location {
										id
										name
										locality {
											id
											name
											region {
												id
												name
											}
										}
										address
										latlng {
											lat
											lng
										}
									}

									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.s,
						category: this.$route.params.category
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.events.data
					this.pagination.pageInfo = data.events.pageInfo
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.promoter-banner {
	margin: 24px 0;
	padding: 34px;
	background-color: #000;
	color: #fff;
	text-align: center;

	p {
		font-size: 1.2rem;
	}

	.btn-outline-light {
		color: #fff;
		border: solid 2px;
		padding: 0.375rem 1.2rem;
		margin: auto;
	}
}
</style>
